import { render, staticRenderFns } from "./RealtimeStationsSettings.vue?vue&type=template&id=431c1b96&"
import script from "./RealtimeStationsSettings.vue?vue&type=script&lang=js&"
export * from "./RealtimeStationsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports